"use client";

import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

type StartingPriceBatch = {
  id: string;
  city: string;
  main_price: number;
};

export default function TripStartingPrice({
  batches,
  fallbackPrice,
  // numberOfNights,
  // numberOfDays,
}: {
  batches: StartingPriceBatch[];
  fallbackPrice: number;
  numberOfNights?: string;
  numberOfDays?: string;
}) {
  const [selectedCity, setSelectedCity] = useState(batches[0]?.city ?? "");
  const price =
    batches.find((batch) => batch.city === selectedCity)?.main_price ??
    fallbackPrice;
  const gstAmount = Number((price * 0.05).toFixed(2));
  const grandTotal = Number((price + gstAmount).toFixed(2));

  return (
    <div className="w-full">

      {/* <div className="flex w-full flex-nowrap justify-between text-base text-gray-600 xl:text-base">
          <p>Starting Price</p>
          <div className="flex flex-col items-center">
            <div className="flex w-fit overflow-hidden rounded border border-black/60 text-center text-lg font-semibold">
              <p className="bg-custom-primary-shade px-1 text-black">
                {numberOfNights} Night
              </p>
              <p className="bg-black px-1 text-white">{numberOfDays} Days</p>
            </div>
            <p className="mt-2 text-xs text-red-500">*Exploration Duration </p>
          </div>
        </div> */}

      <p className="text-xs sm:text-sm text-gray-600">Starting Price (Excl. GST)</p>
      <p className="text-nowrap text-2xl font-semibold text-black lg:text-2xl xl:text-4xl">
        Rs. {price}/
        <span className="text-xl text-zinc-400">pp</span>
      </p>
      <p className="mt-1 text-xs sm:text-sm text-[#00A6A6]">+5% GST Applicable</p>
      <div className="h-px w-full bg-black/25 shadow my-2.5" />

      <p className="text-sm sm:text-base text-black font-medium">From</p>
      {batches.length > 0 && (
        <Tabs
          value={selectedCity}
          onValueChange={setSelectedCity}
          className="my-2"
        >
          <TabsList className="flex flex-nowrap h-auto w-full justify-start gap-1 bg-transparent p-0 overflow-x-auto custom-scrollbar pb-2.5 lg:pb-3.5">
            {batches.map((batch) => (
              <TabsTrigger
                key={batch.id}
                value={batch.city}
                className="rounded-md w-full border border-black/20 px-3 py-1.5 data-[state=active]:border-custom-primary data-[state=active]:bg-custom-primary data-[state=active]:text-white"
              >
                {batch.city}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
      )}

      <div className="p-2.5 border border-custom-primary/50 bg-custom-primary/5 rounded-lg space-y-1 text-sm sm:text-base">
        <div className="flex justify-between">
          <span className="text-gray-600">Base Amount:</span>
          <span className="font-semibold text-gray-800">
            ₹{price.toFixed(2)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">GST (5%):</span>
          <span className="font-semibold text-gray-800">
            ₹{gstAmount.toFixed(2)}
          </span>
        </div>
        <div className="h-px w-full border-t border-custom-primary/25 border-dashed my-1" />
        <div className="flex justify-between text-base sm:text-lg">
          <span className="font-semibold text-primary">
            Grand Total:
          </span>
          <span className="font-bold text-custom-primary">
            ₹{grandTotal.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
}
